import { render, staticRenderFns } from "./BulkSendConfirm.vue?vue&type=template&id=f01230b0&scoped=true&"
import script from "./BulkSendConfirm.vue?vue&type=script&lang=js&"
export * from "./BulkSendConfirm.vue?vue&type=script&lang=js&"
import style0 from "./BulkSendConfirm.vue?vue&type=style&index=0&id=f01230b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01230b0",
  null
  
)

export default component.exports